import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { CommentConfirmDialog } from 'scenes/FinancialResults/components/CommentFormDialog/CommentConfirmDialog';
import { approveFinancialResult } from 'scenes/FinancialResults/sources/financialResults';

import { approve } from '../queryKeyFactory';

export const useApproveFinancialResult = ({ showDraftAlert } = {}) => {
  const showModal = useScreenModalV2(CommentConfirmDialog);
  const approveMutation = useMutation(approve(), approveFinancialResult);

  const handleAction = async (fr) => {
    const { comment } = await showModal({
      fr: fr,
      title: 'Approve Financial Result?',
      confirmActionLabel: 'Approve',
      showDraftAlert,
    });

    await approveMutation.mutateAsync({ id: fr.id, comment });
  };

  return [handleAction, approveMutation];
};
